export const mockUsers = [
  {
    id: 1,
    fname: 'John',
    lname: 'Doe',
    email: 'john.doe@example.com',
    role: 'admin',
    status: 'active',
    company: 'COMP001',
    date_added: '2024-01-15',
    last_login: '2024-01-20 10:30:00',
    phone: '+1-555-0123',
    job_title: 'IT Manager',
    site_id: 1,
    created_at: '2024-01-15T08:00:00Z',
    updated_at: '2024-01-20T10:30:00Z'
  },
  {
    id: 2,
    fname: 'Jane',
    lname: 'Smith',
    email: 'jane.smith@example.com',
    role: 'user',
    status: 'active',
    company: 'COMP002',
    date_added: '2024-01-16',
    last_login: '2024-01-19 14:45:00',
    phone: '+1-555-0124',
    job_title: 'Marketing Specialist',
    site_id: 2,
    created_at: '2024-01-16T09:00:00Z',
    updated_at: '2024-01-19T14:45:00Z'
  },
  {
    id: 3,
    fname: 'Mike',
    lname: 'Johnson',
    email: 'mike.johnson@example.com',
    role: 'user',
    status: 'inactive',
    company: 'COMP003',
    date_added: '2024-01-17',
    last_login: '2024-01-18 16:20:00',
    phone: '+1-555-0125',
    job_title: 'Sales Representative',
    site_id: 3,
    created_at: '2024-01-17T10:00:00Z',
    updated_at: '2024-01-18T16:20:00Z'
  },
  {
    id: 4,
    fname: 'Sarah',
    lname: 'Wilson',
    email: 'sarah.wilson@example.com',
    role: 'user',
    status: 'active',
    company: 'COMP004',
    date_added: '2024-01-18',
    last_login: '2024-01-20 09:15:00',
    phone: '+1-555-0126',
    job_title: 'HR Coordinator',
    site_id: 4,
    created_at: '2024-01-18T11:00:00Z',
    updated_at: '2024-01-20T09:15:00Z'
  },
  {
    id: 5,
    fname: 'David',
    lname: 'Brown',
    email: 'david.brown@example.com',
    role: 'user',
    status: 'active',
    company: 'COMP005',
    date_added: '2024-01-19',
    last_login: '2024-01-20 11:30:00',
    phone: '+1-555-0127',
    job_title: 'Financial Analyst',
    site_id: 5,
    created_at: '2024-01-19T12:00:00Z',
    updated_at: '2024-01-20T11:30:00Z'
  },
  {
    id: 6,
    fname: 'Emily',
    lname: 'Davis',
    email: 'emily.davis@example.com',
    role: 'user',
    status: 'active',
    company: 'COMP006',
    date_added: '2024-01-20',
    last_login: '2024-01-20 13:45:00',
    phone: '+1-555-0128',
    job_title: 'Operations Manager',
    site_id: 6,
    created_at: '2024-01-20T13:00:00Z',
    updated_at: '2024-01-20T13:45:00Z'
  }
];

export const mockUserRoles = [
  { value: 'admin', label: 'Administrator', color: 'bg-red-100 text-red-800' },
  { value: 'user', label: 'User', color: 'bg-green-100 text-green-800' }
];

export const mockUserStatuses = [
  { value: 'active', label: 'Active', color: 'bg-green-100 text-green-800' },
  { value: 'inactive', label: 'Inactive', color: 'bg-gray-100 text-gray-800' },
  { value: 'suspended', label: 'Suspended', color: 'bg-red-100 text-red-800' },
  { value: 'pending', label: 'Pending', color: 'bg-yellow-100 text-yellow-800' }
];

export const mockDepartments = [
  'IT',
  'Marketing',
  'Sales',
  'HR',
  'Finance',
  'Operations',
  'Customer Support',
  'Research & Development'
];
